import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { Ocorrencia, createOcorrenciaSchema, ocorrencia } from 'service/api'
import { toast } from 'sonner'
import { OcorrenciaForm } from './Form'

export default function AdicionarOcorrencias() {
    const { mutateAsync, isLoading } = ocorrencia.mutations.useCreate({
        invalidateQuery: true,
    })

    const handleSubmit: SubmitHandler<Ocorrencia> = async data =>
        mutateAsync(
            {
                ...data,
                pagarVale: data.tipo === 'COMPENSACAO' ? data.pagarVale : 'N',
            },
            {
                onSuccess: () => {
                    toast.success('Ocorrência adicionada com sucesso!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={createOcorrenciaSchema}
            height="auto"
            defaultValues={{ pagarVale: false, tempoAmamentacao: '01:00' }}
            open={hasPermission(['create', 'Ocorrências'])}
        >
            <Dialog.Title>Criar nova ocorrência</Dialog.Title>
            <Dialog.Content dividers>
                <OcorrenciaForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
